import { memo } from 'react';
export default (function (TabComponent) {
  return /*#__PURE__*/memo(TabComponent, function (oldProps, newProps) {
    var id = oldProps.id,
      oldActiveId = oldProps.selectedTabID,
      newActiveId = newProps.selectedTabID;
    return oldActiveId === newActiveId || id !== oldActiveId && id !== newActiveId;
  });
});